import React from 'react';
import { OverlayProps } from 'react-bootstrap';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { UilInfoCircle } from '@iconscout/react-unicons';

interface StandardTooltipProps {
  text: string;
  placement?: OverlayProps['placement'];
  children?: JSX.Element;
  icon?: boolean;
  className?: string;
}

const StandardTooltip = ({
  text,
  children,
  icon,
  className,
  ...props
}: StandardTooltipProps) => {
  const trigger = icon ? (
    <span className={`text-muted d-inline-flex cursor-pointer${className ? ` ${className}` : ''}`}>
      <UilInfoCircle width={16} height={16} />
    </span>
  ) : children!;

  return (
    <>
      {text ? (
        <OverlayTrigger
          placement={props.placement || 'bottom'}
          overlay={<Tooltip id="standard-tooltip">{text}</Tooltip>}
          {...props}
        >
          {trigger}
        </OverlayTrigger>
      ) : (
        trigger
      )}
    </>
  );
};

export default StandardTooltip;
